module.exports = __webpack_public_path__ + "img/chapter-1-thumb.60f756a9.jpg";